module.exports = __webpack_public_path__ + "img/git-merge.812c90ea.svg";